import { Nomenclature } from '@feature/nomenclature';
import { IdentityRequest, PartialAuthor, PublishedAt, PublishedAtRequest } from '@feature/utils';

export interface PublicationIdentifiers {
  wosId: string | null;
  scopusId: string | null;
  doi: string | null;
  wosLink?: string | null;
  scopusLink?: string | null;
}

export const defaultIdentifiers: PublicationIdentifiers = {
  wosLink: null,
  scopusLink: null,
  doi: null,
  scopusId: null,
  wosId: null,
};

export type SourceType = 'WOS' | 'SCOPUS' | 'MANUAL';

export interface Publication {
  id: number;
  title: string;
  createdAt: string;
  language: Nomenclature;
  source: {
    type: SourceType;
  };
  noOfPages: number;
  publishedAt: PublishedAt;
  wosIndexes: Nomenclature[];
  wosCategories: Nomenclature[];
  identifiers: PublicationIdentifiers;

  bdis: Nomenclature[];

  startPage: number;
  endPage: number;

  link: string | null;

  wosIndexingYear: number | null;

  universityAffiliatedNoOfAuthors?: number | null;
  noOfRoAuthors?: number | null;
}

export interface PublicationIdentifiersRequest {
  wosId: string | null;
  scopusId: string | null;
  doi: string | null;
  wosLink?: string | null;
  scopusLink?: string | null;
}

export interface PublicationRequest {
  title: string;
  language: IdentityRequest | null;

  noOfPages: number;
  publishedAt: PublishedAtRequest;

  wosIndexes: IdentityRequest[];
  wosCategories: IdentityRequest[];

  bdis: IdentityRequest[];

  identifiers: PublicationIdentifiersRequest;

  startPage: number;
  endPage: number;

  link: string | null;

  sourceType?: string | null;

  universityAffiliatedNoOfAuthors?: number | null;
}

export interface PublicationSearchRequest {
  doi: string;
  wosId: string;
  scopusId: string;
}

export interface ReclaimRequest {
  publicationId: number;
  authorId: number;
}

export interface ReclaimablePublication {
  id: number;
  title: string;
  authors: PartialAuthor[];
}

export interface PublicationReclaimSearch {
  publication: ReclaimablePublication | null;
}

export interface PublicationFilters {
  sourceType: string | null;
  publishYear: number | null;
  indexingYear: number | null;
}
